import React from 'react'
import {FailedPopIcon } from '../../res/icons' 
import { Button, Grid, Paper, Typography, Dialog } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';


const UserCreationFailedPopup = ({  handleClose }) => {
  return (
    <Dialog open={true} onClose={handleClose}>
      <Grid>
          <Grid style={{ padding: '2rem' }}>
            <Grid style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CloseIcon onClick={handleClose} />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center' }}>
              <FailedPopIcon />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '6%' }}>
              <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}>User Creation Failed!</Typography>
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '6%' }}>
              <Typography color='textSecondary' style={{ fontSize: '16px', textAlign: 'center' }}>
                There was an error creating the user account.
              </Typography>
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: '6%', marginBottom: '4%' }}>
              <Button style={{ color: 'white', backgroundColor: '#185ABD', width: '20%' }} onClick={handleClose}>
                OK
              </Button>
            </Grid>
          </Grid>
      </Grid>
    </Dialog>
  )
}

export default UserCreationFailedPopup
